import { Card, Flex } from "antd";
import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import { buildRoutePath } from "tm-shared/utils";

import { ROUTES } from "@/constants";
import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

interface ProductCardProps {
    product: {
        barcode: string;
        name: string;
    };
    children?: ReactNode;
}

export const ProductCard: FC<ProductCardProps> = ({ product, children }) => {
    return (
        <Card size="small">
            <Flex vertical gap={6}>
                <Flex justify="space-between" align="center" gap={16}>
                    <Link
                        to={buildRoutePath(ROUTES.ProductPage, {
                            barcode: product.barcode,
                        })}
                    >
                        <PrimaryText fontWeight="500">
                            {product.name}
                        </PrimaryText>
                    </Link>
                </Flex>

                <SecondaryText>Штрихкод: {product.barcode}</SecondaryText>

                {children}
            </Flex>
        </Card>
    );
};
